module.exports = __webpack_public_path__ + "static/media/img_header_document_search.a35790d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/assets/img_header_document_search.jpg
// module id = 253
// module chunks = 1